import * as tslib_1 from "tslib";
import { ErrorHandler } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AirportComment } from '../models/airport-comment.model';
var RemarkService = /** @class */ (function () {
    function RemarkService(_http, _errorHandler) {
        this._http = _http;
        this._errorHandler = _errorHandler;
    }
    /**
     * gets admin comments via api
     * @param {number} airportID
     * @return {Promise<Array<AirportComment>>}
     */
    RemarkService.prototype.getRemarks = function (airportID) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var URL, RESPONSE, AIRPORT_ADMIN_COMMENTS, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        URL = environment.airportsApiUrl + "/airports/" + airportID + "/comments";
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._http.get(URL).toPromise()];
                    case 2:
                        RESPONSE = _a.sent();
                        AIRPORT_ADMIN_COMMENTS = (RESPONSE || []).map(function (d) { return AirportComment.parse(d); });
                        // const AIRPORT_ADMIN_COMMENTS = AirportComment.parse(RESPONSE);
                        return [2 /*return*/, AIRPORT_ADMIN_COMMENTS];
                    case 3:
                        e_1 = _a.sent();
                        this._errorHandler.handleError(e_1);
                        throw e_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * updates specified entity via api
     * @param {number} airportID
     * @param {AirportComment} remark
     * @return {Promise<any>}
     */
    RemarkService.prototype.putRemark = function (airportID, remark) {
        var URL = environment.airportsApiUrl + "/airports/" + airportID + "/comments/" + remark.id;
        try {
            var BODY = this._getRemarkJSON(remark);
            return this._http.put(URL, BODY).toPromise();
        }
        catch (e) {
            this._errorHandler.handleError(e);
            throw e;
        }
    };
    /**
     * adds specified entity via api
     * @param {number} airportID
     * @param {AirportComment} remark
     * @return {Promise<any>}
     */
    RemarkService.prototype.postRemark = function (airportID, remark) {
        var URL = environment.airportsApiUrl + "/airports/" + airportID + "/comments/";
        try {
            var BODY = this._getRemarkJSON(remark);
            return this._http.post(URL, BODY).toPromise();
        }
        catch (e) {
            this._errorHandler.handleError(e);
            throw e;
        }
    };
    /**
     * deletes specified entity via api
     * @param {number} airportID
     * @param {number} remarkID
     * @return {Promise<any>}
     */
    RemarkService.prototype.deleteRemark = function (airportID, remarkID) {
        var URL = environment.airportsApiUrl + "/airports/" + airportID + "/comments/" + remarkID;
        try {
            return this._http.delete(URL).toPromise();
        }
        catch (e) {
            this._errorHandler.handleError(e);
            throw e;
        }
    };
    /**
     * converts entity to json obj
     * @param {AirportComment} remark
     * @return {any}
     * @private
     */
    RemarkService.prototype._getRemarkJSON = function (remark) {
        return {
            commentType: AirportComment.formatCommentType(remark.commentType),
            commentRef: remark.commentRef,
            text: remark.text
        };
    };
    return RemarkService;
}());
export { RemarkService };
